<template>
    <div>
        <candidate-banner></candidate-banner>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <candidate-side-nav-layout></candidate-side-nav-layout>
                </div>
                <div class="col-md-9">
                    <updateModal ref="elemSelected"></updateModal>
<!--                    <section>-->
<!--                        <div class="dash-inner-box">-->
<!--                            <div class="row">-->
<!--                                <div class="col-md-12">-->
<!--                                    <div class="dashboard-heading">-->
<!--                                        <div class="row">-->
<!--                                            <div class="col-md-6">-->
<!--                                                <h1>Personal Information</h1>-->
<!--                                            </div>-->
<!--                                            &lt;!&ndash;                                <div class="col-md-6">&ndash;&gt;-->
<!--                                            &lt;!&ndash;                                    <div class="edit-btn">&ndash;&gt;-->
<!--                                            &lt;!&ndash;                                        <button @click="updateModal(null, 'a')"><i class="far fa-edit"></i></button>&ndash;&gt;-->
<!--                                            &lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--                                            &lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-md-12">-->
<!--                                    <div class="row">-->
<!--                                        <div class="col-md-6">-->
<!--                                            <div class="pd-sec-box">-->
<!--                                                <i class="fas fa-user-tie"></i> Name-->
<!--                                                <p>{{name}}</p>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-6">-->
<!--                                            <div class="pd-sec-box">-->
<!--                                                <i class="fas fa-map-marker-alt"></i> Loction-->
<!--                                                <p>{{location}}</p>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="row">-->
<!--                                        <div class="col-md-6">-->
<!--                                            <div class="pd-sec-box padd-top-10">-->
<!--                                                <i class="fas fa-university"></i> {{ this.$store.getters.getUser['business_activity'] }}-->
<!--                                                <p v-html="college"></p>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-6">-->
<!--                                            <div class="pd-sec-box padd-top-10">-->
<!--                                                <i class="fas fa-envelope"></i> Email-->
<!--                                                <p>{{email}}</p>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="row">-->
<!--                                        <div class="col-md-6">-->
<!--                                            <div class="pd-sec-box">-->
<!--                                                <i class="fas fa-mobile-alt"></i> Phone-->
<!--                                                <p>{{phone}}</p>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </section>-->
                    <section>
                        <div class="dash-inner-box">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="dashboard-heading">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <h1>About Me</h1>
                                            </div>
<!--                                            <div class="col-md-6">-->
<!--                                                <div class="edit-btn">-->
<!--                                                    <button @click="updateModal(null,'about')"><i-->
<!--                                                            class="far fa-edit"></i></button>-->
<!--                                                </div>-->
<!--                                            </div>-->
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="about-me-box">
                                        <textarea id="description" class="form-control dash-input" rows="6" v-model="about_description" @change="saveAbout()">{{description}}</textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="margin-top-20">
                        <div class="dash-inner-box">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="dashboard-heading">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <h1>Educational Background</h1>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="edit-btn">
                                                    <button @click="updateModal(null, 'education')"><i
                                                            class="far fa-edit"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <ul class="edu-sec">
                                        <li v-for="edu in edu_detail">
                                            <div class="edu-box">
                                                <div class="edu-title"><i class="fas fa-graduation-cap"></i>{{edu.degree}}
                                                </div>
                                                <div class="edu-date">{{edu.from_date}} - {{edu.to_date}}</div>
                                                <div class="edu-college">{{edu.institute}}</div>
                                                <div class="edu-edit-btn">
                                                    <button @click="updateModal(edu.education_enc_id,'education')"><i
                                                            class="fas fa-pen"></i></button>
                                                </div>
                                                <div class="edu-edit-btn e-remove">
                                                    <button @click="removeEdu(edu.education_enc_id)"><i
                                                            class="fas fa-times"></i></button>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="margin-top-20">
                        <div class="dash-inner-box">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="dashboard-heading">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h1>Skills</h1>
                                            </div>
                                            <!--                                            <div class="col-md-6">-->
                                            <!--                                                <div class="edit-btn">-->
                                            <!--                                                    <button @click="updateModal(null, 'skills')"><i-->
                                            <!--                                                            class="far fa-edit"></i>-->
                                            <!--                                                    </button>-->
                                            <!--                                                </div>-->
                                            <!--                                            </div>-->
                                        </div>
                                    </div>
                                </div>
                                <!--                                <div class="col-md-12">-->
                                <!--                                    <div class="skills">-->
                                <!--                                        <ul>-->
                                <!--                                            <li v-for="skill in skills">{{skill.value}}</li>-->
                                <!--                                        </ul>-->
                                <!--                                    </div>-->
                                <!--                                </div>-->
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group padd-20-left">
                                        <multiselect v-model="skillSelectedTags" :options="skill_existing_tags" label="value" track-by="key" :internal-search="true" open-direction="bottom"
                                                     :multiple="true" :hide-selected="true" :closeOnSelect="true" placeholder="Enter Atleast One Skill"  @select="validateEnterKey" @remove="validateEnterKey">
                                            <span slot="noOptions">Enter any keyword to search</span>
                                            <span slot="noResult">No skill found. Enter Another Keyword to search</span>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="margin-top-20">
                        <div class="dash-inner-box">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="dashboard-heading">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <h1>Work Experience</h1>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="edit-btn">
                                                    <button @click="updateModal(null, 'work')"><i
                                                            class="far fa-edit"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <ul class="edu-sec">
                                        <li v-for="it in work_detail">
                                            <div class="edu-box">
                                                <div class="edu-title"><i class="fas fa-briefcase"></i> {{it.title}}
                                                </div>
                                                <div class="edu-date"> {{it.from_date}} - {{it.to_date}}</div>
                                                <div class="edu-college">{{it.company}}</div>
                                                <div class="edu-des">{{it.description}}</div>
                                                <div class="edu-edit-btn">
                                                    <button @click="updateModal(it.id,'work')"><i
                                                            class="fas fa-pen"></i></button>
                                                </div>
                                                <div class="edu-edit-btn e-remove">
                                                    <button @click="removeWork(it.id)"><i class="fas fa-times"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import updateModal from './../../components/updateModal.vue';
    import axios from 'axios';
    import CandidateBanner from "../../components/candidateBanner";
    import CandidateSideNavLayout from '../../components/CandidateSideNavLayout.vue';
    import {mapState} from 'vuex';
    import toastr from "../../../public/js/toastr";
    import Multiselect from "vue-multiselect";
    import Vue from "vue";
    import {requestHeaders} from "../../_helpers/apiHelper";

    Vue.component('multiselect', Multiselect)

    export default {
        components: {
            updateModal,
            CandidateBanner,
            CandidateSideNavLayout,
            Multiselect
        },
        data() {
            return {
                items: [],
                name: '',
                location: '',
                email: '',
                phone: '',
                college: '',
                description: '',
                edu_detail: '',
                work_detail: '',
                skills: '',
                about_description: '',
                skillSelectedTags: [],
                skill_existing_tags: [],
            }
        },
        mounted() {
            var t = this;
            var user = this.$store.getters.getUser;
            this.items = this.$store.getters.getExperience;
            var url = this.$store.getters.getDomain;

            t.name = user['first_name'] + '  ' + user['last_name'];
            t.phone = user['phone'];
            t.email = user['email'];
            t.location = user['city'];
            t.college = user['college'];

            axios.post(`${url}api/v2/cand-resume/fetch-details`, '', {
                headers: requestHeaders()
            }).then(function (response) {
                var description = response['data']['response']['about']['description'];
                var edu_detail = response['data']['response']['education'];
                var work_detail = response['data']['response']['experience'];
                var skills = response['data']['response']['skills'];

                // //loop to get skills
                for (var i = 0; i < skills.length; i++) {
                    var demo = {};
                    demo['key'] = skills[i]['skill_enc_id'];
                    demo['value'] = skills[i]['skill'];
                    t.skillSelectedTags.push(demo)
                }

                t.$store.dispatch("setAbout", description);
                t.$store.dispatch("saveEducation", edu_detail);
                t.$store.dispatch("saveExperience", work_detail);
                t.$store.dispatch("setSkills", t.skillSelectedTags);

                t.description = t.about_description = t.$store.getters.getAbout;
                t.edu_detail = t.$store.getters.getEducation;
                t.work_detail = t.$store.getters.getExperience;
                t.skills = t.$store.getters.getSkills;
            }).catch(function (error) {
                console.log(error)
            });
            axios.post(`${url}api/v2/cand-profile/get-skills`, '', {}).then(function (response) {
                t.skill_existing_tags = response['data']['response'];
            });

            // var newExperience = {
            //     id: 1,
            //     title: 'Web Developer',
            //     duration : '2016-2018',
            //     company : 'Empower Youth',
            //     description : ''
            // }
            // this.$store.dispatch('saveExperience', newExperience)
        },
        computed: {
            changeAbout() {
                return this.$store.getters.getAbout;
            },
            changeEdu() {
                return this.$store.getters.getEducation;
            },
            changeWork() {
                return this.$store.getters.getExperience;
            },
            changeSkills() {
                return this.$store.getters.getSkills;
            }
        },
        watch: {
            changeAbout(value) {
                var t = this;
                t.description = value;
            },
            changeEdu(value) {
                var t = this;
                t.edu_detail = value;
            },
            changeWork(value) {
                var t = this;
                t.work_detail = value;
            },
            changeSkills(value) {
                var t = this;
                t.skills = value;
            }
        },
        methods: {
            updateModal(id = null, type = null) {
                if (id && type == 'education') {
                    this.$refs.elemSelected.setEduFields(this.$store.getters.getEducationById(id), type);
                    $('#updateModal').css({"display": "block"});
                } else if (id && type == 'work') {
                    this.$refs.elemSelected.setWorkFields(this.$store.getters.getExperienceById(id), type);
                    $('#updateModal').css({"display": "block"});
                } else {
                    this.$refs.elemSelected.enableForm(type);
                    $('#updateModal').css({"display": "block"});
                }
            },
            removeEdu(id) {
                var t = this;
                var data = {'id': id};
                var url = t.$store.getters.getDomain;

                axios.post(`${url}api/v2/cand-resume/remove-edu`, data, {
                    headers: requestHeaders()
                }).then(function (response) {
                    var edu_data = response['data']['response']['edu'];
                    t.$store.dispatch("saveEducation", edu_data);
                }).catch(function (error) {
                    // console.log(error)
                });
            },
            removeWork(id) {
                var t = this;
                var data = {'id': id};
                var url = t.$store.getters.getDomain;

                axios.post(`${url}api/v2/cand-resume/remove-exp`, data, {
                    headers: requestHeaders()
                }).then(function (response) {
                    // console.log(response);
                    var work = response['data']['response']['work'];
                    t.$store.dispatch("saveExperience", work);
                }).catch(function (error) {
                    // console.log(error)
                });
            },
            saveAbout: function () {
                var t = this;

                var data = {'description': t.about_description};
                var url = t.$store.getters.getDomain;

                axios .post(`${url}api/v2/cand-resume/save-about`, data, {
                    headers: requestHeaders()
                }).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.$store.dispatch('setAbout', t.about_description);
                        toastr.success('Resume Updated ', 'Success');
                    }
                }).catch(function (error) {
                    console.log(error)
                });
            },
            saveSkills: function () {
                var t = this;
                var data = {'skills': t.skillSelectedTags};
                var url = t.$store.getters.getDomain;

                axios.post(`${url}api/v2/cand-resume/save-skills`, data, {
                    headers: requestHeaders()
                }).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        var skills = response['data']['response']['skills'];
                        t.skillSelectedTags = [];
                        //loop to get skills
                        for (var i = 0; i < skills.length; i++) {
                            var demo = {};
                            demo['key'] = skills[i]['skill_enc_id'];
                            demo['value'] = skills[i]['skill'];
                            t.skillSelectedTags.push(demo)
                        }
                        t.$store.dispatch('setSkills', t.skillSelectedTags);
                    }
                }).catch(function (error) {
                    console.log(error)
                });
            },
            validateEnterKey: function(e) {
                // if (e.keyCode === 13) {
                var t = this;
                setTimeout(function (){
                    t.saveSkills();
                },1000)
                // }
            },
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>